import { int64, timestamp, Timestamp } from '@fullstory/proto/google/protobuf';
import { HeatmapDetail, UnnamedHeatmap } from '@fullstory/proto/fs/services/dx-objects';
import { Scope } from '@fullstory/proto/fs/api/search';
import { mockAuditMetadata } from '../shared';
import { Device, Platform } from '@fullstory/proto/fs/api/segment';
import { HeatmapSettings } from '@fullstory/proto/fs/services/search-settings/visualizationsettings';

export const MOCK_HEATMAP_ID = '17';
export const MOCK_HEATMAP_ALT_ID = '18';
export const MOCK_HEATMAP_TABLET_ID = '19';
export const MOCK_HEATMAP_PREDETERMINED_ID = '20';
export const MOCK_CONVERSION_MAP_ID = '21';

export const mockHeatmapWithOldSession: HeatmapDetail = {
  heatmap: {
    heatmap: {
      id: '1',
      name: 'Untitled Heatmap',
      description: 'this is a description',
      heatmapEvent: {
        primary: { visitedPage: { equals: { value: [int64.fromNumber(3)], spec: [] } } },
        deps: [],
      },
      representativePage: {
        userId: int64.fromNumber(2),
        sessionId: int64.fromNumber(3),
        pageId: int64.fromNumber(4),
        pageDefLastUpdatedAt: '2021-06-10T06:00:27.071Z' as timestamp,
        pageStartAt: null,
        timestampPredetermined: false,
      },
      heatmapSettings: {
        segment: { segmentId: 'everyone', segmentScope: Scope.SCOPE_INDIVIDUAL },
        device: Device.DEVICE_DESKTOP,
        timeRange: {
          startTime: 'NOW/DAY-6DAY',
          endTime: 'NOW/DAY+1DAY',
        },
        heatmapType: HeatmapSettings.HeatmapType.HEATMAP_TYPE_CLICK,
        secondaryHeatmapType: HeatmapSettings.ClickType.CLICK_TYPE_ALL_CLICKS,
        conversionEvent: null,
        focusElementId: '',
        focusOnlyOnSelection: false,
        groupByElementProperty: '',
      },
    },
    metadata: mockAuditMetadata(),
  },
  starred: false,
  lastViewed: Timestamp.now(),
};

export const HeatmapRepresentativePageStart = 1686147895040;

export const mockHeatmapDetail: HeatmapDetail = {
  heatmap: {
    heatmap: {
      id: MOCK_HEATMAP_ID,
      name: 'Untitled Heatmap',
      description: 'this is a description',
      heatmapEvent: {
        primary: { visitedPage: { equals: { value: [int64.fromNumber(3)], spec: [] } } },
        deps: [
          {
            platform: {
              equals: {
                value: [Platform.PLATFORM_WEB],
              },
            },
          },
        ],
      },
      representativePage: {
        userId: int64.fromNumber(2),
        sessionId: int64.fromNumber(3),
        pageId: int64.fromNumber(4),
        pageDefLastUpdatedAt: '2021-06-10T06:00:27.071Z' as timestamp,
        pageStartAt: Timestamp.fromMillis(HeatmapRepresentativePageStart),
        timestampPredetermined: true,
      },
      heatmapSettings: {
        segment: { segmentId: 'everyone', segmentScope: Scope.SCOPE_INDIVIDUAL },
        device: Device.DEVICE_DESKTOP,
        timeRange: {
          startTime: 'NOW/DAY-6DAY',
          endTime: 'NOW/DAY+1DAY',
        },
        heatmapType: HeatmapSettings.HeatmapType.HEATMAP_TYPE_CLICK,
        secondaryHeatmapType: HeatmapSettings.ClickType.CLICK_TYPE_ALL_CLICKS,
        conversionEvent: null,
        focusElementId: '',
        focusOnlyOnSelection: false,
        groupByElementProperty: '',
      },
    },
    metadata: mockAuditMetadata(),
  },
  starred: false,
  lastViewed: Timestamp.now(),
};

export const mockConversionMapDetail: HeatmapDetail = {
  heatmap: {
    heatmap: {
      id: MOCK_CONVERSION_MAP_ID,
      name: 'Mock Conversion Map',
      description: 'this is a description',
      heatmapEvent: {
        primary: { visitedPage: { equals: { value: [int64.fromNumber(3)], spec: [] } } },
        deps: [
          {
            platform: {
              equals: {
                value: [Platform.PLATFORM_WEB],
              },
            },
          },
        ],
      },
      representativePage: {
        userId: int64.fromNumber(2),
        sessionId: int64.fromNumber(3),
        pageId: int64.fromNumber(4),
        pageDefLastUpdatedAt: '2021-06-10T06:00:27.071Z' as timestamp,
        pageStartAt: Timestamp.fromMillis(HeatmapRepresentativePageStart),
        timestampPredetermined: true,
      },
      heatmapSettings: {
        segment: { segmentId: 'everyone', segmentScope: Scope.SCOPE_INDIVIDUAL },
        device: Device.DEVICE_DESKTOP,
        timeRange: {
          startTime: 'NOW/DAY-6DAY',
          endTime: 'NOW/DAY+1DAY',
        },
        heatmapType: HeatmapSettings.HeatmapType.HEATMAP_TYPE_CONVERSION,
        secondaryHeatmapType: HeatmapSettings.ClickType.CLICK_TYPE_ALL_CLICKS,
        conversionEvent: {
          primary: {
            visitedPage: {
              equals: {
                value: [int64.fromNumber(1)],
                spec: [],
              },
            },
          },
          deps: [],
        },
        focusElementId: '',
        focusOnlyOnSelection: false,
        groupByElementProperty: '',
      },
    },
    metadata: mockAuditMetadata(),
  },
  starred: false,
  lastViewed: Timestamp.now(),
};

export const mockHeatmapDetailTablet: HeatmapDetail = {
  heatmap: {
    heatmap: {
      id: MOCK_HEATMAP_TABLET_ID,
      name: 'Untitled Heatmap',
      description: 'this is a description',
      heatmapEvent: {
        primary: { visitedPage: { equals: { value: [int64.fromNumber(3)], spec: [] } } },
        deps: [
          {
            platform: {
              equals: {
                value: [Platform.PLATFORM_WEB],
              },
            },
          },
        ],
      },
      representativePage: {
        userId: int64.fromNumber(2),
        sessionId: int64.fromNumber(3),
        pageId: int64.fromNumber(4),
        pageDefLastUpdatedAt: '2021-06-10T06:00:27.071Z' as timestamp,
        pageStartAt: null,
        timestampPredetermined: false,
      },
      heatmapSettings: {
        segment: { segmentId: 'everyone', segmentScope: Scope.SCOPE_INDIVIDUAL },
        device: Device.DEVICE_TABLET,
        timeRange: {
          startTime: 'NOW/DAY-6DAY',
          endTime: 'NOW/DAY+1DAY',
        },
        heatmapType: HeatmapSettings.HeatmapType.HEATMAP_TYPE_SCROLL,
        secondaryHeatmapType: HeatmapSettings.ClickType.CLICK_TYPE_INVALID,
        conversionEvent: null,
        focusElementId: '',
        focusOnlyOnSelection: false,
        groupByElementProperty: '',
      },
    },
    metadata: mockAuditMetadata(),
  },
  starred: false,
  lastViewed: Timestamp.now(),
};

export const mockHeatmapDetailWithPredeterminedTimestamp: HeatmapDetail = {
  heatmap: {
    heatmap: {
      id: MOCK_HEATMAP_PREDETERMINED_ID,
      name: 'Untitled Heatmap',
      description: 'this is a description',
      heatmapEvent: {
        primary: { visitedPage: { equals: { value: [int64.fromNumber(3)], spec: [] } } },
        deps: [
          {
            platform: {
              equals: {
                value: [Platform.PLATFORM_WEB],
              },
            },
          },
        ],
      },
      representativePage: {
        userId: int64.fromNumber(2),
        sessionId: int64.fromNumber(3),
        pageId: int64.fromNumber(4),
        pageDefLastUpdatedAt: '2021-06-10T06:00:27.071Z' as timestamp,
        pageStartAt: '2021-06-10T06:00:27.071Z' as timestamp,
        timestampPredetermined: true,
      },
      heatmapSettings: {
        segment: { segmentId: 'everyone', segmentScope: Scope.SCOPE_INDIVIDUAL },
        device: Device.DEVICE_DESKTOP,
        timeRange: {
          startTime: 'NOW/DAY-6DAY',
          endTime: 'NOW/DAY+1DAY',
        },
        heatmapType: HeatmapSettings.HeatmapType.HEATMAP_TYPE_CLICK,
        secondaryHeatmapType: HeatmapSettings.ClickType.CLICK_TYPE_ALL_CLICKS,
        conversionEvent: null,
        focusElementId: '',
        focusOnlyOnSelection: false,
        groupByElementProperty: '',
      },
    },
    metadata: mockAuditMetadata(),
  },
  starred: false,
  lastViewed: Timestamp.now(),
};

export const mockHeatmapDetailWithUpdatedPageDefinition: HeatmapDetail = {
  heatmap: {
    heatmap: {
      id: MOCK_HEATMAP_ALT_ID,
      name: 'Untitled Heatmap',
      description: 'this is a description',
      heatmapEvent: {
        primary: { visitedPage: { equals: { value: [int64.fromNumber(3)], spec: [] } } },
        deps: [
          {
            platform: {
              equals: {
                value: [Platform.PLATFORM_WEB],
              },
            },
          },
        ],
      },
      representativePage: {
        userId: int64.fromNumber(5671563168841728),
        sessionId: int64.fromNumber(5629499534213120),
        pageId: int64.fromNumber(4),
        pageDefLastUpdatedAt: '2020-06-10T06:00:27.071Z' as timestamp,
        pageStartAt: null,
        timestampPredetermined: false,
      },
      heatmapSettings: {
        segment: { segmentId: 'everyone', segmentScope: Scope.SCOPE_INDIVIDUAL },
        device: Device.DEVICE_DESKTOP,
        timeRange: {
          startTime: 'NOW/DAY-6DAY',
          endTime: 'NOW/DAY+1DAY',
        },
        heatmapType: HeatmapSettings.HeatmapType.HEATMAP_TYPE_CLICK,
        secondaryHeatmapType: HeatmapSettings.ClickType.CLICK_TYPE_ALL_CLICKS,
        conversionEvent: null,
        focusElementId: '',
        focusOnlyOnSelection: false,
        groupByElementProperty: '',
      },
    },
    metadata: mockAuditMetadata(),
  },
  starred: false,
  lastViewed: Timestamp.now(),
};

export const mockHeatmapDetailWithUrl: HeatmapDetail = {
  heatmap: {
    heatmap: {
      id: MOCK_HEATMAP_ID,
      name: 'Untitled Heatmap',
      description: 'this is a description',
      heatmapEvent: {
        primary: {
          visitedUrl: {
            equals: {
              value: [{ value: 'https://fruitshoppe.firebaseapp.com/#/cart', category: 1 }],
            },
          },
        },
        deps: [
          {
            platform: {
              equals: {
                value: [Platform.PLATFORM_WEB],
              },
            },
          },
        ],
      },
      representativePage: {
        userId: int64.fromNumber(2),
        sessionId: int64.fromNumber(3),
        pageId: int64.fromNumber(4),
        pageDefLastUpdatedAt: '2021-06-10T06:00:27.071Z' as timestamp,
        pageStartAt: null,
        timestampPredetermined: false,
      },
      heatmapSettings: {
        segment: { segmentId: 'everyone', segmentScope: Scope.SCOPE_INDIVIDUAL },
        device: Device.DEVICE_DESKTOP,
        timeRange: {
          startTime: 'NOW/DAY-6DAY',
          endTime: 'NOW/DAY+1DAY',
        },
        heatmapType: HeatmapSettings.HeatmapType.HEATMAP_TYPE_CLICK,
        secondaryHeatmapType: HeatmapSettings.ClickType.CLICK_TYPE_ALL_CLICKS,
        conversionEvent: null,
        focusElementId: '',
        focusOnlyOnSelection: false,
        groupByElementProperty: '',
      },
    },
    metadata: mockAuditMetadata(),
  },
  starred: false,
  lastViewed: Timestamp.now(),
};

export const mockOmnisearchHeatmap: UnnamedHeatmap = {
  heatmap: {
    id: '',
    name: '',
    description: '',
    heatmapEvent: {
      primary: { visitedPage: { equals: { value: [int64.fromNumber(10)], spec: [] } } },
      deps: [
        {
          platform: {
            equals: {
              value: [Platform.PLATFORM_WEB],
            },
          },
        },
      ],
    },
    representativePage: {
      userId: int64.fromNumber(12),
      sessionId: int64.fromNumber(13),
      pageId: int64.fromNumber(14),
      pageDefLastUpdatedAt: '2021-06-10T06:00:27.071Z' as timestamp,
      pageStartAt: null,
      timestampPredetermined: false,
    },
    heatmapSettings: {
      segment: { segmentId: 'everyone', segmentScope: Scope.SCOPE_INDIVIDUAL },
      device: Device.DEVICE_DESKTOP,
      timeRange: {
        startTime: 'NOW/DAY-6DAY',
        endTime: 'NOW/DAY+1DAY',
      },
      heatmapType: HeatmapSettings.HeatmapType.HEATMAP_TYPE_CLICK,
      secondaryHeatmapType: HeatmapSettings.ClickType.CLICK_TYPE_ALL_CLICKS,
      conversionEvent: null,
      focusElementId: '',
      focusOnlyOnSelection: false,
      groupByElementProperty: '',
    },
  },
};

export const mockUnnamedHeatmap: UnnamedHeatmap = {
  heatmap: {
    id: MOCK_HEATMAP_ID,
    name: 'My Unnamed Heatmap',
    description: 'This one is unnamed',
    heatmapEvent: {
      primary: { visitedPage: { equals: { value: [int64.fromNumber(99)], spec: [] } } },
      deps: [
        {
          platform: {
            equals: {
              value: [Platform.PLATFORM_WEB],
            },
          },
        },
      ],
    },
    representativePage: {
      userId: int64.fromNumber(2),
      sessionId: int64.fromNumber(3),
      pageId: int64.fromNumber(4),
      pageDefLastUpdatedAt: '2021-06-10T06:00:27.071Z' as timestamp,
      pageStartAt: null,
      timestampPredetermined: false,
    },
    heatmapSettings: {
      segment: { segmentId: 'everyone', segmentScope: Scope.SCOPE_INDIVIDUAL },
      device: Device.DEVICE_DESKTOP,
      timeRange: {
        startTime: 'NOW/DAY-6DAY',
        endTime: 'NOW/DAY+1DAY',
      },
      heatmapType: HeatmapSettings.HeatmapType.HEATMAP_TYPE_CLICK,
      secondaryHeatmapType: HeatmapSettings.ClickType.CLICK_TYPE_ALL_CLICKS,
      conversionEvent: null,
      focusElementId: '',
      focusOnlyOnSelection: false,
      groupByElementProperty: '',
    },
  },
};
